export default class CbarImgCache {
  get cache() {
    if( !this.__imageCache ) {
      this.__imageCache = {};
    }

    return this.__imageCache;
  }

  getBase64(src) {
    return new Promise((res, rej) => {
      if( this.cache.hasOwnProperty(src) ) {
        return res(this.cache[ src ]);
      }

      return this._cacheImage(src).then(base64 => res(base64));
    })
  }

  _cacheImage(src) {
    let img = new Image();
    img.crossOrigin = 'anonymous';

    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext('2d');

    return new Promise((res, rej) => {
      img.onload = () => {
        canvas.height = img.naturalHeight;
        canvas.width = img.naturalWidth;

        ctx.drawImage(img, 0, 0);

        this.cache[ img.src ] = canvas.toDataURL();

        res(this.cache[ img.src ]);
      };

      img.src = src;
    });
  }
}
